export default __webpack_public_path__ + "static/imperfect-foods-logo-ac9ca8d9f6d0186bc1ffbd282a56841c.svg";